import { render, staticRenderFns } from "./ListUpcoming.vue?vue&type=template&id=6a8ff770&scoped=true"
import script from "./ListUpcoming.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListUpcoming.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListUpcoming.vue?vue&type=style&index=0&id=6a8ff770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8ff770",
  null
  
)

export default component.exports